/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput
    // ICreateActionContext
} from '@msdyn365-commerce/core';

import { getNomenclatureBundleDetailsAsync } from './DataService/DataActionExtension.g';

export class GetNomenclatureBundleDetailsInput implements IActionInput {
    public itemId: string;
    public quantity: number;

    constructor(itemId: string, quantity: number | string) {
        this.itemId = itemId;
        this.quantity = typeof quantity === 'string' ? +quantity : quantity;
    }

    public getCacheKey = () => `GetNomenclatureBundleDetailsInput`;
    public getCacheObjectType = () => 'GetNomenclatureBundleDetailsInput';
    public dataCacheType = (): CacheType => 'none';
}

const createInput = (itemId: string, quantity: number | string): IActionInput => {
    return new GetNomenclatureBundleDetailsInput(itemId, quantity);
};

export async function GetNomenclatureBundleDetailsJson(input: GetNomenclatureBundleDetailsInput, ctx: IActionContext): Promise<string> {
    return getNomenclatureBundleDetailsAsync({ callerContext: ctx }, input.itemId, input.quantity)
        .then(data => {
            return data.jsonString;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-nomenclature-bundle-details] Unable to load bundle list');
            throw new Error('[get-nomenclature-bundle-details] Unable to load bundle list');
        });
}

export default createObservableDataAction({
    action: <IAction<string>>GetNomenclatureBundleDetailsJson,
    id: 'GetNomenclatureBundleDetails',
    input: createInput
});
